import type { FaireProductEntity } from "../../entity_types/product";

export const p_7j3c4verxh: FaireProductEntity = {
  token: "p_7j3c4verxh",
  type: "product",
  name: "Slinky Dog Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1880874e49c7933a2d1cf9a10c771e83ce288a5fca2dd6dc20b5017d8d914266.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1c73b0e538eeb704339336dbca9080fca76d4ad533b24dc7cf8aad1e6e907e7.png",
    "https://cdn.faire.com/fastly/4d925e72b2a57615cbd8ae039e0e25d4b0231227354423dff53fe86bed6904c0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:04.808Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
